import { render, staticRenderFns } from "./section0.vue?vue&type=template&id=0d80db7c"
import script from "./section0.vue?vue&type=script&lang=js"
export * from "./section0.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports